<template lang="html">
  <v-container fill-height fluid class="home flex-column justify-center align-center primary--text">
    <h1>{{ $t('welcomeToQweb') }}</h1>
    <h3>{{ $t('portalDescription') }}</h3>
    <br>
    <p>{{ $t('pleaseLogin') }}</p>
  </v-container>
</template>
<script>
export default {
  name: "WelcomeView"
}
</script>